import { render, staticRenderFns } from "./HeadImg.vue?vue&type=template&id=01aa22f4&scoped=true"
import script from "./HeadImg.vue?vue&type=script&lang=js"
export * from "./HeadImg.vue?vue&type=script&lang=js"
import style0 from "./HeadImg.vue?vue&type=style&index=0&id=01aa22f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa22f4",
  null
  
)

export default component.exports